import { render, staticRenderFns } from "./TopBannerSettingListPage.vue?vue&type=template&id=795ad92e&scoped=true"
import script from "./TopBannerSettingListPage.vue?vue&type=script&lang=js"
export * from "./TopBannerSettingListPage.vue?vue&type=script&lang=js"
import style0 from "./TopBannerSettingListPage.vue?vue&type=style&index=0&id=795ad92e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795ad92e",
  null
  
)

export default component.exports